import moment from "moment";
import { HorizontalFlex } from "../pandora/styled";
import { CaseLogType } from "types";

type LogProps = {
  caseLogs: Array<CaseLogType>;
  isModal?: boolean;
};
export default function DisplayLogs({
  caseLogs,
  isModal = false,
}: Readonly<LogProps>) {
  return (
    <>
      {caseLogs?.length ? (
        <>
          {!isModal && <hr />}
          <div style={{ textAlign: "left", margin: "20px 0 20px 0" }}>
            <strong>Aktiviteter</strong>
          </div>
          <div style={{ display: "flex", flexFlow: "column", gap: "4px" }}>
            {caseLogs.map((data, index) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontSize: "12px",
                    border: "1px solid #A6A6A6",
                    borderRadius: "4px",
                    background: "white",
                    height: "70px",
                    textAlign: "center",
                  }}
                  key={data.Date + index}
                >
                  <div
                    style={{
                      width: "110px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "4px",
                      marginRight: "4px",
                    }}
                  >
                    {moment(data.Date).format("DD MMM YYYY")}
                    <br />
                    {moment(data.Date).format("HH:mm:ss")}
                  </div>
                  <span
                    style={{
                      borderLeft: "1px solid #A6A6A6",
                      height: "80%",
                      alignSelf: "center",
                    }}
                  />
                  <div
                    style={{
                      display: "block",
                      alignItems: "center",
                      width: "100%",
                      marginLeft: "20px",
                      marginRight: "auto",

                      placeContent: "center",
                    }}
                  >
                    {data.Activity}
                    <br /> {data.User && "Ansvarig: " + data.User}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <HorizontalFlex>No Logs</HorizontalFlex>
      )}
    </>
  );
}
